import { gql } from 'apollo-angular';
import { secondFactorMinimalFragment } from '../minimal.fragments';

export const viewerWithSecondFactorQuery = gql`
  query ViewerWithSecondFactor {
    viewer {
      id
      isAdmin
      email
      isOnboarded
      secondFactor {
        ...SecondFactorMinimal
      }
      userLoginInformation {
        hasUsedSingleSignOn
      }
    }
  }
  ${secondFactorMinimalFragment}
`;
